import { SectionHeading } from './SectionHeading'

const FEATURES = [
  {
    icon: '🤖',
    title: 'AIを駆使した開発手法',
    description:
      '基礎構築をAIが担い、エンジニアはクリエイティブ・戦略的領域に集中。ユーザー視点のUI追求とビジネス理解に基づくシステム提案を得意としています。'
  },
  {
    icon: '⚙️',
    title: '熟成された技術にも精通',
    description:
      'スマホネイティブアプリ・業務用WEBシステム・Windowsアプリ・組み込み機器との連携などのモダンなものからレガシーな技術まで対応可能です。'
  },
  {
    icon: '🏢',
    title: 'ジョルダン（株）100%子会社',
    description:
      'ジョルダン株式会社（東証:3710）の100%子会社。グループの知見と開発力で大規模開発にも対応可能です。'
  }
]

export function Features() {
  return (
    <section
      id="features"
      className="section-wrapper relative overflow-hidden bg-white"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-blue-50/40" />

      <div className="container-inner relative z-10">
        <SectionHeading subtitle="Our Strengths" title="当社の特徴" />

        <div className="grid md:grid-cols-3 gap-6">
          {FEATURES.map((f, i) => (
            <div
              key={f.title}
              className={`animate-on-scroll animate-on-scroll-delay-${(i % 3) + 1} bg-white border border-slate-100 rounded-2xl p-8 shadow-sm hover:shadow-md hover:border-brand-cyan/40 transition-all duration-300 group`}
            >
              <div className="text-4xl mb-5">{f.icon}</div>
              <h3 className="text-lg font-bold text-brand-navy mb-3 group-hover:text-brand-blue transition-colors">
                {f.title}
              </h3>
              <p className="text-brand-navy/60 text-sm leading-relaxed">
                {f.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
